import { T } from "./profileMenuItems.tlocale";

interface MenuArgs {
  goTo: (
    p:
      | "profile"
      | "favorites"
      | "orders"
      | "subscriptions"
      | "returns"
      | "addresses"
      | "payment_methods"
      | "store_credit"
      | "reset_password"
  ) => void;
  logout: () => void;
  hasSavedCards: boolean;
}

export function getMenuItems(args: MenuArgs) {
  return [
    {
      id: "profile",
      kind: "button" as const,
      label: T("Profile"),
      onClick: () => {
        args.goTo("profile");
      },
    },
    {
      id: "favorites",
      kind: "button" as const,
      label: T("Saved Items"),
      onClick: () => {
        args.goTo("favorites");
      },
    },
    {
      id: "subscriptions",
      kind: "button" as const,
      label: T("Subscriptions"),
      onClick: () => {
        args.goTo("subscriptions");
      },
    },
    {
      id: "orders",
      kind: "button" as const,
      label: T("Order History"),
      onClick: () => {
        args.goTo("orders");
      },
    },
    {
      id: "returns",
      kind: "button" as const,
      label: T("Returns"),
      onClick: () => {
        args.goTo("returns");
      },
    },
    {
      id: "addresses",
      kind: "button" as const,
      label: T("Address Book"),
      onClick: () => {
        args.goTo("addresses");
      },
    },
    ...(args.hasSavedCards
      ? [
          {
            id: "payment_methods",
            kind: "button" as const,
            label: T("Payment Info"),
            onClick: () => {
              args.goTo("payment_methods");
            },
          },
        ]
      : []),
    {
      id: "store_credit",
      kind: "button" as const,
      label: T("Store Credit"),
      onClick: () => {
        args.goTo("store_credit");
      },
    },
    {
      id: "reset_password",
      kind: "button" as const,
      label: T("Reset Password"),
      onClick: () => {
        args.goTo("reset_password");
      },
    },
    { id: "logout", kind: "button" as const, label: T("Log Out"), onClick: args.logout },
  ];
}
